import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../http/http-client.service';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Observable } from 'rxjs';
import { JsonPipe } from '@angular/common';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class PinPadWebTefService {
  connection$: WebSocketSubject<any>;

  constructor(private http: HttpClient, private httpService: HttpService) { }

   connect(): Observable<any> {
    this.connection$ = webSocket({
      url: `ws://localhost:8083/webtefapi`,
      deserializer: (data) => data,
      serializer: (data) => data,
    });

    this.connection$.error = (event) => console.log('error', event)

    return this.connection$;
  }


  send(data: any): void {
    if (this.connection$) {
      this.connection$.next(JSON.stringify(data));
    } else {
      console.log('Did not send data, unable to open connection');
    }
  }

  closeConnection(): void {
    if (this.connection$) {
      this.connection$.complete();
      this.connection$ = null;
    }
  }

  ngOnDestroy() {
    this.closeConnection();
  }

  pinpadAlive() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/testAlive", {params, observe: "response"});
  }

  findPorts() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/findPorts", {params});
  }

  openPort(data: any) {
    let params = data;
    return this.http.post("http://localhost:8080/sdkadiq/openSafePort", null, {params});
  }

  getSerial() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/getSerial", {params});
  }

  closePort() {
    let params = {};
    return this.http.get("http://localhost:8080/sdkadiq/closePort", {params});
  }

}
